module.exports = __webpack_public_path__ + "img/clipboard.9044caf7.svg";